/* An optional, local choice of next step. Links remain usable without JavaScript. */
(function () {
  'use strict';
  function mount(root) {
    if (root.dataset.enhanced) return;
    var choices = Array.from(root.querySelectorAll('[data-pg-next-choice]'));
    var panels = Array.from(root.querySelectorAll('[data-pg-next-panel]'));
    var group = root.querySelector('[data-pg-next-choices]');
    if (!group || choices.length !== 4 || panels.length !== 4) return;
    function select(key) {
      if (!panels.some(function (panel) { return panel.dataset.pgNextPanel === key; })) return;
      choices.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.pgNextChoice === key)); });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.pgNextPanel !== key; });
    }
    choices.forEach(function (button) {
      button.addEventListener('click', function () { select(button.dataset.pgNextChoice); });
    });
    select(choices[0].dataset.pgNextChoice);
    root.dataset.enhanced = 'true';
    group.hidden = false;
  }
  function boot() { document.querySelectorAll('[data-pg-next-step]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
